import { useState } from 'react';  // ReactのuseStateフックをインポート
import { Auth } from 'aws-amplify';  // AWS AmplifyのAuthモジュールをインポート

// APIリクエストを処理するカスタムフックの定義
const ApiRequest = () => {
  // 状態の定義: response, error, isLoading
  const [response, setResponse] = useState(null);  // APIからの応答を保持する状態
  const [error, setError] = useState(null);  // APIリクエスト中のエラーを保持する状態
  const [isLoading, setIsLoading] = useState(false);  // ローディング中かどうかを示す状態

  // APIリクエストを実行する関数の定義
  const fetchData = async (url, data) => {
    setIsLoading(true);  // ローディング中フラグをtrueに設定
    // console.log(response);

    try {
      const user = await Auth.currentAuthenticatedUser();  // 認証されたユーザーを取得
      const idToken = "Bearer " + user.signInUserSession.idToken.jwtToken;

      // fetch関数を使用してAPIリクエストを実行
      const response = await fetch(url, {
        method: 'POST',  // POSTメソッドを使用
        headers: {
          'Content-Type': 'application/json',  // コンテンツタイプをJSONに設定
          'Authorization': idToken,  // 認証トークンをヘッダーに追加
        },
        body: JSON.stringify(data),  // データをJSON文字列に変換してリクエストのボディに設定
      });

      if (response.ok) {
        const responseData = await response.json();
        setResponse(responseData);
        return responseData;  // 取得データを戻り値として返す
      }
       else {  // レスポンスがエラーの場合
        const errorMsg = `API Request Error: ${response.status} ${response.statusText}`;
        setError(errorMsg);  // エラーメッセージを設定
      }
    } catch (error) {  // エラーが発生した場合
      let errorMsg = 'API Request Error: ';
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        errorMsg = 'ネットワークエラーが発生しました。インターネット接続を確認してください。';
      } else {
        errorMsg = error.message;
      }
      setError(errorMsg);  // エラーメッセージを設定
    } finally {  // 必ず実行される処理
      setIsLoading(false);  // ローディング中フラグをfalseに設定
    }
  };

  // response, error, isLoading, fetchDataを返す
  return { response, error, isLoading, fetchData };
};

export default ApiRequest;  // ApiRequestカスタムフックをエクスポート
